"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const modal_dialog_1 = require("../modal-dialog");
class MessageDialog extends modal_dialog_1.default {
    // CAUTION  never ever try to store any dynamic state in a
    // MessageDialog object since it is treated as immutable
    // Currently, solely ActiveModalDialog is known to be capable of
    // representing individual dialog instances.
    constructor(_messageDialogConfig = {}) {
        super(_messageDialogConfig); // call ModalDialog's constructor
        this._messageDialogConfig = _messageDialogConfig;
    }
    getCssClass() {
        return this._messageDialogConfig.cssClass || "message-modal-dialog";
    }
    get bodySelector() {
        const selector = this._messageDialogConfig.bodySelector || ".message-modal-body";
        return `${this.rootSelector} ${selector}`;
    }
    get messageTextSelector() {
        const selector = this._messageDialogConfig.messageTextSelector || ".message-text";
        return `${this.bodySelector} ${selector}`;
    }
    get messageText() {
        return this._messageDialogConfig.messageText;
    }
    handleButtonClick(buttonIdentifier, resultCallback) {
        this.hide();
        if (resultCallback) {
            resultCallback(buttonIdentifier);
        }
    }
    toString() {
        return `Message Dialog "${this.messageText}"`;
    }
    setContentVisibility(visible) {
        const text = this.messageText;
        // show my modal body
        this.setVisibilityBySelector(this.bodySelector, visible);
        // set my modal text
        this.setTextBySelector(this.messageTextSelector, visible ? text : "");
        // show my modal footer
        this.setVisibilityBySelector(this.footerSelector, visible);
    }
}
exports.default = MessageDialog;
